import en from './en';
import no from './no';
import nn from './nn';

const translations = { en, no, nn };

export default translations;
